const MEASUREMENT_ID_FORMAT = /^G-[A-Z0-9]{4,}$/;

/**
 * GA4 measurement id, injected at build time. Empty in development and in the
 * sandbox, which keeps analytics off there. A malformed value is ignored
 * rather than pasted into a script URL.
 */
export function resolveMeasurementId(raw: string | undefined): string {
  const value = (raw ?? '').trim();
  return MEASUREMENT_ID_FORMAT.test(value) ? value : '';
}

export const GA_MEASUREMENT_ID = resolveMeasurementId(import.meta.env.VITE_GA_MEASUREMENT_ID);
